var exports = {
  "R": "FriendsList.module__friendsListContainer___ZXphT0",
  "X": "FriendsList.module__scroller___ZXphT0",
};

module.exports = exports;
